import FormattedDateComponent from "@/components/formatted/FormattedDateComponent.vue";
import FormattedNumberComponent from "@/components/formatted/FormattedNumberComponent.vue";
import FormattedMinutesComponent from "@/components/formatted/FormattedMinutesComponent.vue";

export { FormattedDateComponent, FormattedNumberComponent, FormattedMinutesComponent };
